<template>
  <div class="container">
    <div class="content-teasers row row-narrow text-center">
      <div
        v-for="(item, index) in teaserElements.slice(0,3)"
        :key="item.href + '_' + index"
        :class="`content-teaser col-md-6 ${teaserVariant}`"
      >
        <template
          v-if="item.href"
        >
          <a
            :href="arp_linkBuilder(item.href)"
            @[eventCondition].prevent="arp_linkClicker(item.href)"
          >
            <div class="body">
              <component
                :is="headingType"
                class="header"
              >{{ $t(item.head) }}</component>
              <div class="main">
                <div v-dompurify-html="$t(item.html)" />
              </div>
              <div class="footer">
                <div class="padding">
                  <div
                    class="btn btn-line"
                  >
                    {{ $t(item.title) }}
                  </div>
                </div>
              </div>
            </div>
          </a>
        </template>
        <template
          v-else
        >
          <div>
            <div class="body">
              <component
                :is="headingType"
                class="header"
              >
                {{ $t(item.head) }}
              </component>
              <div class="main">
                <div v-dompurify-html="$t(item.html)" />
              </div>
              <div class="footer">
                <div class="padding">
                  <div
                    v-if="item.title"
                    class="btn btn-line"
                  >
                    {{ $t(item.title) }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import AnchorRouterPush from 'mixins/AnchorRouterPush';

export default {
  name: 'ContentTextTeaser',
  mixins: [AnchorRouterPush],
  props: {
    teaserElements: {
      required: false,
      type: Array,
      default: () => [],
    },
    teaserVariant: {
      required: false,
      type: String,
      default: 'dark',
    },
    headingType: {
      required: false,
      type: String,
      default: 'h4',
    },
  },
  computed: {
    eventCondition() {
      if (!(typeof this.item?.href === 'string' && this.item?.href.search(/^(http|\/\/)/) !== -1)) {
        return 'click';
      }
      return null;
    },
  },
};
</script>
